module.exports = __webpack_public_path__ + "assets/media/april.29a26906.svg";